const TeamData = {
  "2025-26": {
    president: [
      {
        name: "Benjamin Doley",
        image: "president/Benjamin.jpg",
      },
    ],
    sscom: [
      {
        name: "Anupal Goswami",
        image: "scoor/Anupal.jpeg",
      },
      {
        name: "Geetanjali Basumatary",
        image: "scoor/Geetanjali.jpeg",
      },
      {
        name: "Lucy Venuh",
        image: "scoor/Lucy.jpeg",
      },
      {
        name: "Biki Verma",
        image: "scoor/Biki.jpeg",
      },
      {
        name: "Liyanthung Ngullie",
        image: "scoor/Liyanthung.jpeg",
      },
      {
        name: "Bijoy Timung",
        image: "Governors/Bijoy.jpg",
      },
      {
        name: "Deepraj Das",
        image: "Governors/Deepraj.jpg",
      },
      {
        name: "Mingma Rinzing Lepcha",
        image: "Governors/Mingma.jpg",
      },
      {
        name: "Vedic Dutta",
        image: "Governors/Vedic.jpg",
      },
    ],

    //yet to be updated
    SeniorCoordinator: [
      {
        name: "Chonesa Weang Ch Marak",
        image: "scoor/Chonesa.jpeg",
      },
      {
        name: "Huidrom Rohitkumar Meitei",
        image: "scoor/Huidrom.jpeg",
      },
      {
        name: "Rahul Basumatary",
        image: "scoor/Rahul.jpeg",
      },
      {
        name: "Vetshekhro Doulo",
        image: "scoor/Vetshekhro.jpeg",
      },
    ],
    governors: [
      {
        name: "Pratiksha Boro",
        image: "Heads/Pratiksha.jpeg",
      },
      {
        name: "Shrewa Shree Konika P Bharti ",
        image: "Heads/Shrewa.jpeg",
      },
      {
        name: "Gracy Debbarma",
        image: "Heads/Gracy.jpg",
      },
      {
        name: "Biswajit Das",
        image: "Heads/Biswajit.jpg",
      },
      {
        name: "Kamdek Kapnang",
        image: "Heads/Kamdek.jpg",
      },
      {
        name: "Abinash Doley",
        image: "Heads/AbinashDoley.jpeg",
      },
      {
        name: "Himangshu Sonowal",
        image: "Heads/Himangshu.jpeg",
      },
      {
        name: "Pakde Pumbu",
        image: "Heads/Pakde.jpg",
      },
      {
        name: "Likha Ang",
        image: "Heads/Likha.jpg",
      },
      {
        name: "Jahnu Bora",
        image: "Heads/Jahnu.jpeg",
      },
    ],
    executiveHead: [
      {
        name: "Bidisha Khakhlary",
        image: "sem/Bidisha.jpeg",
      },
    ],
    mediaPublicityHead: [
      {
        name: "Mrithunjoy Basumatary",
        image: "sem/Mrithunjoy.jpeg",
      },
    ],
    financeHead: [
      {
        name: "Glory Narzari",
        image: "sem/Glory.jpeg",
      },
    ],
    studentsWelfareHead: [
      {
        name: "Repheka Pakyntein",
        image: "sem/Repheka.jpeg",
      },
      {
        name: "Awang P Yimupushu",
        image: "sem/Awang.jpg",
      },
    ],
    eventsHead: [
      {
        name: "Biri Yachu",
        image: "sem/Yachu.jpg",
      },
      {
        name: "Kaling Tayeng",
        image: "sem/Kaling.jpeg",
      },
    ],
    logisticsHead: [
      {
        name: "Mintu Boro",
        image: "sem/Mintu.jpeg",
      },
      {
        name: "Prithiviraj Nunisa",
        image: "sem/Phrithiviraj.jpeg",
      },
    ],
    webHead: [
      {
        name: "Gracy Debbarma",
        image: "Heads/Gracy.jpg",
      },
      {
        name: "Penuel Daimari",
        image: "Heads/Penuel.jpeg",
      },
    ],
    sem: [
      {
        name: "Jeet Saha",
        image: "jem/Jeet.jpeg",
      },
      {
        name: "Sanjay Ray",
        image: "jem/Sanjay.jpeg",
      },
      {
        name: "Bidintha Basumatary",
        image: "jem/Bidintha.jpeg",
      },
      {
        name: "Keshab Kayal",
        image: "jem/Keshab.jpeg",
      },
      {
        name: "Bijitgiri Basumatary",
        image: "jem/Bijit.jpeg",
      },
      {
        name: "Hiran Jyoti Deori",
        image: "jem/Hiran.jpeg",
      },
      {
        name: "Lakhyajit Basumatary",
        image: "jem/Lakhyajit.jpeg",
      },
      {
        name: "Shashwat Gogoi",
        image: "jem/Shashwat.jpeg",
      },
      {
        name: "Yugam Jain",
        image: "jem/Yugam.jpeg",
      },
      {
        name: "Soumar Jyoti Borah",
        image: "jem/Soumar.jpeg",
      },
    ],
    jem: [
      {
        name: "Sougrakpam Albert Singh",
        image: "jem/Albert.jpg",
      },
      {
        name: "Akangsa Nunisa",
        image: "jem/Akangsa.png",
      },
      {
        name: "Barli Ardao",
        image: "jem/Barli Ardao.png",
      },
      {
        name: "Jash Jain",
        image: "jem/Jash Jain.jpg",
      },
      {
        name: "Raktim Baruah",
        image: "jem/Raktim.png",
      },
      {
        name: "Vaibhav Agarwal",
        image: "jem/Vaibhav_.jpg",
      },
      {
        name: "Hrangromawi Hmar",
        image: "jem/Mawihmar_.jpg",
      },
      {
        name: "Anton Doley",
        image: "jem/Anton Doley.jpg",
      },
      {
        name: "Mithinga Mushahary",
        image: "jem/Mithinga.jpg",
      },
      {
        name: "Lakhyajit Mech",
        image: "jem/Lakhyajit.jpg",
      },
      {
        name: "Ngaworshin Shirak Pheirei",
        image: "jem/Shin.jpg",
      },
      {
        name: "Shownok Dutta Choudhury",
        image: "jem/Shownok Dutta Choudhury.jpg",
      },
    ],
  },
  "2024-25": {
    president: [
      {
        name: "Techi Tina Tara",
        image: "president/Tina.jpg",
      },
    ],
    sscom: [
      {
        name: "Rajdeep Thaosen",
        image: "sscom/Rajdeep.jpeg",
      },
      {
        name: "Zingya C Raman",
        image: "sscom/Zingya.jpeg",
      },
      {
        name: "Moarenla Longkumer",
        image: "sscom/Moarenla.jpg",
      },
      {
        name: "Trishna Das",
        image: "sscom/Trishna.jpeg",
      },
      {
        name: "Darshana Deka",
        image: "sscom/Darshana.jpeg",
      },
      {
        name: "Marian Lepcha",
        image: "sscom/Mariam.jpeg",
      },
      {
        name: "H. Zothanpuii",
        image: "sscom/Zothanpuii.jpeg",
      },
      {
        name: "Rose Merry Basumatary",
        image: "sscom/Rose.jpeg",
      },
    ],
    SeniorCoordinator: [
      {
        name: "Biki Verma",
        image: "scoor/Biki.jpeg",
      },
      {
        name: "Anupal Goswami",
        image: "scoor/Anupal.jpeg",
      },
      {
        name: "Lucy Venuh",
        image: "scoor/Lucy.jpeg",
      },
      {
        name: "Haripriya Boruah",
        image: "scoor/Haripriya.jpeg",
      },
      {
        name: "Liyanthung Ngullie",
        image: "scoor/Liyanthung.jpeg",
      },
      {
        name: "Geetanjali Basumatary",
        image: "scoor/Geetanjali.jpeg",
      },
    ],
    governors: [
      {
        name: "Benjamin Doley",
        image: "Governors/Benjamin.jpg",
      },
      {
        name: "Bijoy Timung",
        image: "Governors/Bijoy.jpg",
      },
      {
        name: "Deepraj Das",
        image: "Governors/Deepraj.jpg",
      },
      {
        name: "Mingma Rinzing Lepcha",
        image: "Governors/Mingma.jpg",
      },
      {
        name: "Vedic Dutta",
        image: "Governors/Vedic.jpg",
      },
    ],
    executiveHead: [
      {
        name: "Biswajit Das",
        image: "Heads/Biswajit.jpg",
      },
      {
        name: "Pratiksha Boro",
        image: "Heads/Pratiksha.jpeg",
      },
    ],
    mediaPublicityHead: [
      {
        name: "Kamdek Kapnang",
        image: "Heads/Kamdek.jpg",
      },
    ],
    financeHead: [
      {
        name: "Shrewa Shree Konika P Bharti ",
        image: "Heads/Shrewa.jpeg",
      },
    ],
    studentsWelfareHead: [
      {
        name: "Pakde Pumbu",
        image: "Heads/Pakde.jpg",
      },
    ],
    eventsHead: [
      {
        name: "Likha Ang",
        image: "Heads/Likha.jpg",
      },
      {
        name: "Jahnu Bora",
        image: "Heads/Jahnu.jpeg",
      },
    ],
    logisticsHead: [
      {
        name: "Abinash Doley",
        image: "Heads/AbinashDoley.jpeg",
      },
      {
        name: "Himangshu Sonowal",
        image: "Heads/Himangshu.jpeg",
      },
    ],
    webHead: [
      {
        name: "Gracy Debbarma",
        image: "Heads/Gracy.jpg",
      },
      {
        name: "Penuel Daimari",
        image: "Heads/Penuel.jpeg",
      },
    ],
    sem: [
      {
        name: "Mintu Boro",
        image: "sem/Mintu.jpeg",
      },
      {
        name: "Prithiviraj Nunisa",
        image: "sem/Phrithiviraj.jpeg",
      },
      {
        name: "Mrithunjoy Basumatary",
        image: "sem/Mrithunjoy.jpeg",
      },
      {
        name: "Pratik Ghosh",
        image: "sem/Pratik.jpeg",
      },
      {
        name: "Abhinash Jimey",
        image: "sem/Abhinash.jpg",
      },
      {
        name: "Repheka Pakyntein",
        image: "sem/Repheka.jpeg",
      },
      {
        name: "Kaling Tayeng",
        image: "sem/Kaling.jpeg",
      },
      {
        name: "Bidisha Khakhlary",
        image: "sem/Bidisha.jpeg",
      },
      {
        name: "Glory Narzari",
        image: "sem/Glory.jpeg",
      },
      {
        name: "Biri Yachu",
        image: "sem/Yachu.jpg",
      },
      {
        name: "Awang P Yimupushu",
        image: "sem/Awang.jpg",
      },
      {
        name: "Robiatnam N Marak",
        image: "sem/Robi.jpg",
      },
    ],
    jem: [
      {
        name: "Hiran Jyoti Deori",
        image: "jem/Hiran.jpeg",
      },
      {
        name: "Soumar Jyoti Borah",
        image: "jem/Soumar.jpeg",
      },
      {
        name: "Lakhyajit Basumatary",
        image: "jem/Lakhyajit.jpeg",
      },
      {
        name: "Bidintha Basumatary",
        image: "jem/Bidintha.jpeg",
      },
      {
        name: "Sandeep Sikia",
        image: "jem/Sandeep.jpeg",
      },
      {
        name: "Jeet Saha",
        image: "jem/Jeet.jpeg",
      },
      {
        name: "Satyam Chakravorty",
        image: "jem/Satyam.jpeg",
      },
      {
        name: "Keshab Kayal",
        image: "jem/Keshab.jpeg",
      },
      {
        name: "Yugam Jain",
        image: "jem/Yugam.jpeg",
      },
      {
        name: "Manish Paul",
        image: "jem/Manish.jpeg",
      },
      {
        name: "Shashwat Gogoi",
        image: "jem/Shashwat.jpeg",
      },
      {
        name: "Sanjay Ray",
        image: "jem/Sanjay.jpeg",
      },
      {
        name: "Bijitgiri Basumatary",
        image: "jem/Bijit.jpeg",
      },
    ],
  },
};

// Helper to get data for specific year
export const getYearData = (year) => {
  return TeamData[year] || TeamData["2025-26"]; // Fallback to current year
};

export default TeamData;
